export default "__VITE_ASSET__BjtY3PNl__"